import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { UserEntitlementsData } from '@app/models/row-data.interface';
import { serverHelpers } from '@app/helpers/server.helpers';
import { EligibilityData, EligibilityPeriod } from '@app/employees/models/eligibility-periods.model';

import { EmployeesRepoService } from './employees-repo.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {
  constructor(private _employeesRepoService: EmployeesRepoService) {}

  getEmployeesData(): Observable<UserEntitlementsData[]> {
    return this._employeesRepoService.getEmployeesData().pipe(
      map((employeesList) => {
        employeesList.forEach((employee: UserEntitlementsData) => {
          serverHelpers.rowValues(employee);
        });
        return employeesList;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      })
    );
  }

  getEligibilityData(username: string): Observable<EligibilityData> {
    return this._employeesRepoService.getEligibilityData(username);
  }

  postEligibilityData(username: string, eligibilityPeriods: EligibilityPeriod[]): Observable<EligibilityData> {
    return this._employeesRepoService.postEligibilityData(username, eligibilityPeriods);
  }

  updateEmployeeAccessLevel(role: string, username: string): Observable<UserEntitlementsData> {
    const sentRole = serverHelpers.accessLevel(role);
    return this._employeesRepoService.updateEmployeeAccessLevel(sentRole, username);
  }
}
